// removed by extract-text-webpack-plugin
module.exports = {"content":"GoogleLoginUnavailable__content","title":"GoogleLoginUnavailable__title","message":"GoogleLoginUnavailable__message","okButton":"GoogleLoginUnavailable__okButton","growDotQello":"GoogleLoginUnavailable__growDotQello","growDotBlue":"GoogleLoginUnavailable__growDotBlue","growDotGolden":"GoogleLoginUnavailable__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/GoogleLoginUnavailable/GoogleLoginUnavailable.scss
// module id = 1870
// module chunks = 0